"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilSigmaModelSignal = void 0;
const zod_1 = require("zod");
const hil_signal_js_1 = require("./hil-signal.js");
const hilSigmaModelSignalSchema = hil_signal_js_1.HilSignal.schema
    .pick({
    id: true,
    name: true,
    description: true,
    attributes: true,
    direction: true,
    floatingBehavior: true,
    ties: true,
})
    .extend({
    isOptional: zod_1.z.boolean().default(false),
    aliases: zod_1.z.string().array().default([]),
    allowAutoMapping: zod_1.z.boolean().default(false),
    allowMultiMapping: zod_1.z.boolean().default(false),
    isConnector: zod_1.z.boolean().default(false),
    repeatableBlock: zod_1.z.string().nullable().default(null),
});
exports.HilSigmaModelSignal = {
    create(input) {
        return hilSigmaModelSignalSchema.parse(input);
    },
    schema: hilSigmaModelSignalSchema,
};
//# sourceMappingURL=hil-sigma-model-signal.js.map